import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ReallocationSource } from '../../../types/reallocation/Reallocation'
import { updateReallocation } from '../service/reallocationService'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'
import reallocationQueryKeys from './reallocationQueryKeys'
import invalidateReportQueries from './invalidateReportQueries'

export const useUpdateReallocation = () => {
  const { companyId } = useContextParameters()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (reallocation: ReallocationSource) => {
      if (!companyId) {
        throw new Error('Company ID is required')
      }
      return updateReallocation(reallocation, companyId)
    },
    onSuccess: updatedItem => {
      queryClient.setQueryData<ReallocationSource[]>(reallocationQueryKeys.list({ companyId }), old => {
        if (!Array.isArray(old)) return old
        return old.map(item => (item.id === updatedItem.id ? { ...item, ...updatedItem } : item))
      })
      invalidateReportQueries(queryClient)
    },
    onError: error => {
      console.error('Failed to update reallocation:', error)
    }
  })
}
